var version = {
    "name":      "dativery",
    "buildDateCode": "20260306-102947",
    "buildDate": "Fri Mar 06 2026 10:29:47 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260306-102947",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;